<template>
  <div
    v-if="isInited"
    class="container"
  >
    <div class="header">
      <FormActionBtns
        v-model="status"
        :onAdd="add"
        :hiddenAdd="!hasSettingUpdateAccess"
        :onCancel="cancel"
        :onSave="save"
        :hiddenEdit="!showEdit"
        :hiddenCancel="!hasList"
      />
    </div>
    <div class="tab-group">
      <div
        v-if="isAdd"
        class="tab active"
      >
        {{ $t('settings.department.newDepartment') }}
      </div>
      <div
        v-for="(obj, index) in list"
        :key="index"
        class="tab"
        :class="!isAdd && index === curIndex ? 'active' : ''"
        :title="obj.name"
        @click="onTabClick(obj, index)"
      >
        {{ obj.shortname }}
      </div>
    </div>
    <div class="form-container">
      <div>
        <InputField
          v-for="(item, index) in items"
          :key="index"
          v-hkldinput
          :autoTrim="true"
          :showFlag="true"
          :showColon="false"
          :showEmptyDash="true"
          :required="item.required"
          :readonly="(!isEdit && !isAdd) || !hasSettingUpdateAccess"
          :label="$t(`settings.department.${item.name}`)"
          :value="formData[item.name]"
          :dirtyCheck="true"
          @updateValue="val => onInputChange(item.name, val)"
        />
      </div>
      <Sep v-if="!isAdd" />
      <TabCards
        v-if="!isAdd"
        ref="tabCards"
        v-model="formData"
        :formOptions="formOptions"
      />
    </div>
  </div>
</template>
<script>
import container from './container'
export default container
</script>
<style scoped lang="scss">
.container {
  margin: 0 auto;
  padding-left: 24px;
  padding-right: 24px;
  max-width: 1440px;
}
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
}
.tab-group {
  padding-top: 12px;
  padding-bottom: 7px;
  display: flex;
  flex-wrap: wrap;
  background-color: #f8f8f8;
  .tab {
    margin-right: 5px;
    margin-bottom: 5px;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 24px;
    padding-right: 24px;
    min-width: 75px;
    max-width: 250px;
    background-color: #fff;
    color: #0C3A58;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &.active {
      background-color: #0C3A58;
      color: #fff;
    }
  }
}
.form-container {
  padding-left: 12px;
  padding-right: 12px;
  background-color: #fff;
}
.input-field {
  max-width: 800px;
}
</style>
